import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTypedTheme } from '@monorepo-web/styles';
import { helperFormat, FormatTypes } from '@monorepo-web/utils';
import { Box, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFull } from '@fortawesome/free-solid-svg-icons';
export const useFormatFunction = (value, isPercentToggle, moneyPrefix, valueType, decimals) => helperFormat(value[1] ? value[1] - value[0] : value, valueType !== null && valueType !== void 0 ? valueType : (isPercentToggle ? FormatTypes.percentage : FormatTypes.monetary_extense), decimals !== null && decimals !== void 0 ? decimals : 2, moneyPrefix);
export function barTextPropertiesFunction(value, isNegative, data, isHorizontal) {
    let maiorBarra = 0;
    let menorBarra = 0;
    let percentBarra = 0;
    let numeroPositivos = 0;
    let numeroNegativos = 0;
    let numeroNulos = 0;
    data === null || data === void 0 ? void 0 : data.forEach((item) => {
        if (item > maiorBarra) {
            maiorBarra = item;
        }
        if (item < menorBarra) {
            menorBarra = item;
        }
        if (item > 0) {
            numeroPositivos += 1;
        }
        else if (item < 0) {
            numeroNegativos += 1;
        }
        else {
            numeroNulos += 1;
        }
    });
    if (typeof value == 'number') {
        if (maiorBarra != 0 && maiorBarra >= Math.abs(menorBarra)) {
            percentBarra = Math.abs(value / maiorBarra);
        }
        else if (menorBarra != 0 && maiorBarra < Math.abs(menorBarra)) {
            percentBarra = Math.abs(value / menorBarra);
        }
    }
    else if (value === null || value === void 0 ? void 0 : value[1]) {
        if (maiorBarra != 0 && maiorBarra >= Math.abs(menorBarra)) {
            percentBarra = Math.abs(value[1] - value[0] / maiorBarra);
        }
        else if (menorBarra != 0 && maiorBarra < Math.abs(menorBarra)) {
            percentBarra = Math.abs(value[1] - value[0] / menorBarra);
        }
    }
    let outsideBar = true;
    let onlyBar = false;
    if (maiorBarra >= Math.abs(menorBarra)) {
        outsideBar = percentBarra < 0.8; //Se a barra for grande o suficiente o texto vai ficar dentro dela
        if (Math.abs(menorBarra / maiorBarra) > 0.35) {
            outsideBar = percentBarra < 0.8 && value != menorBarra; //A maior barra do menor lado funciona similarmente
        }
    }
    else {
        outsideBar = percentBarra < 0.8;
        if (Math.abs(maiorBarra / menorBarra) > 0.35) {
            outsideBar = percentBarra < 0.8 && value != maiorBarra;
        }
    }
    if (((!isNegative && numeroPositivos == 1) || //Se só tiver uma barra de um lado, ou tiver espaço para o texto horizontal, aí o texto aparece normalmente
        (isNegative && numeroNegativos == 1) ||
        numeroNegativos + numeroPositivos + numeroNulos < 5) &&
        !isHorizontal) {
        outsideBar = true;
        onlyBar = true;
    }
    return { outsideBar, onlyBar };
}
export const CustomLabelFunction = (moneyPrefix, x, y, value, width, height, isPercentToggle, isBarChart, dispatchPDF, isMobile, listaValores, isHorizontal) => {
    const theme = useTypedTheme();
    const screenWidth = window.innerWidth;
    let isNegative = false;
    if (typeof value == 'number') {
        isNegative = value < 0;
    }
    else {
        isNegative = value[1] - value[0] < 0;
    }
    const { outsideBar, onlyBar } = barTextPropertiesFunction(value, isNegative, listaValores, isHorizontal);
    function xLabelConfig() {
        if (isHorizontal && isBarChart && isMobile)
            return x + width + 20;
        if (isHorizontal && isBarChart && !isMobile)
            return x + width + 37;
        if (isHorizontal && !isBarChart && isMobile)
            return screenWidth / 1.37;
        if (isHorizontal && !isBarChart && !isMobile && isNegative)
            return x + width + 55;
        if (isHorizontal && !isBarChart && !isMobile && !isNegative)
            return x + width + 45;
        return x + width / 2;
    }
    function dyLabelConfig() {
        if (isHorizontal)
            return 0.5 * height;
        if (isMobile && !onlyBar && !dispatchPDF)
            return 3.5;
        if (isNegative)
            return 16;
        if (!isNegative)
            return -5;
    }
    function dxLabelConfig() {
        if (isHorizontal && !isBarChart && isMobile)
            return 0;
        if (isHorizontal && !isBarChart && !isMobile)
            return -100;
        if (isMobile && !onlyBar && !dispatchPDF) {
            if ((outsideBar && isNegative && (!isHorizontal || !isBarChart)) ||
                (!outsideBar && !isNegative && (!isHorizontal || !isBarChart)))
                return -24;
            if ((outsideBar && !isNegative && (!isHorizontal || !isBarChart)) ||
                (!outsideBar && isNegative))
                return 24;
        }
        return 0;
    }
    return (_jsx("text", Object.assign({ x: xLabelConfig(), y: y, dy: dyLabelConfig(), dx: dxLabelConfig(), fill: theme.fontColor, fontWeight: !dispatchPDF ? 'bold' : '', fontSize: !dispatchPDF && isMobile ? 9 : '', textAnchor: "middle", transform: !dispatchPDF && isMobile && !onlyBar && !isHorizontal
            ? `rotate(270, ${x + width / 2}, ${y})`
            : '' }, { children: useFormatFunction((value === null || value === void 0 ? void 0 : value[1]) ? value[1] - value[0] : value, isPercentToggle, moneyPrefix) })));
};
export const renderLegendFunction = ({ payload }, isPercentToggle, moneyPrefix) => {
    const theme = useTypedTheme();
    if (payload.length % 2 !== 0) {
        payload.push({ id: '', value: '' });
    }
    return (_jsx(Grid, Object.assign({ container: true, style: { marginTop: 16, fontSize: 12, height: 150, overflowY: 'auto' }, justifyContent: "space-evenly" }, { children: payload.map((entry, index) => (_jsx(React.Fragment, { children: gridItem({
                index,
                id: entry.id,
                value: entry.value,
                color: theme.chartColors[index % theme.chartColors.length],
                isPercentToggle: isPercentToggle,
                moneyPrefix,
            }) }, index))) })));
};
const gridItem = ({ index, id, value, color, isPercentToggle, moneyPrefix, }) => {
    return (_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, sx: { whiteSpace: 'nowrap' } }, { children: id ? (_jsx(_Fragment, { children: _jsxs(Grid, Object.assign({ container: true, style: { color: '#596579', fontWeight: 500, padding: '10px' } }, { children: [_jsxs(Grid, Object.assign({ item: true, xs: 10, style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        } }, { children: [_jsx(FontAwesomeIcon, { icon: faSquareFull, style: { color, marginRight: 4 } }), ' ', _jsx("span", { children: id })] })), _jsx(Grid, Object.assign({ item: true, xs: 2 }, { children: _jsx(Box, Object.assign({ display: "flex", justifyContent: "flex-end" }, { children: _jsx("b", { children: useFormatFunction(value, isPercentToggle, moneyPrefix) }) })) }))] })) })) : null }), `item-${index}`));
};
// Se poucos meses fazem parte do gráfico de linha e de área, o eixo X será mostrado com dias, ao invés de repetir os meses
export const xAxisRepeatsMonths = (data) => {
    const numMesesData = data === null || data === void 0 ? void 0 : data.reduce((num, item) => {
        if (!(num === null || num === void 0 ? void 0 : num.includes(item.name))) {
            num.push(item.name);
        }
        return num;
    }, []);
    return numMesesData.length < 8;
};
